import { Button, Divider, Form, Grid, Input, InputNumber, Space } from "@arco-design/web-react";
import { IconCopy, IconLeft } from "@arco-design/web-react/icon";
import { copy } from "../utils/copy";
import React, { useEffect, useState } from "react";
import { check } from "../utils/check";
import { toHValue } from "../utils/wrap";
import { usePasswordCheck } from "../hooks/usePasswordCheck";

const FormItem = Form.Item;
const Row = Grid.Row;
const Col = Grid.Col;
const ArcCalculation = ({ onPasswordInvalid }) => {
  const { checkPasswordBeforeAction } = usePasswordCheck(onPasswordInvalid);
  const [btnState1, setBtnState1] = useState({ calc: false, reset: false });
  const [btnState2, setBtnState2] = useState({ calc: false, reset: false });
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const STORAGE_KEY = "lc_values_v1";
  const loadAll = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  };
  const saveAll = (data) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  };
  const persist = () => {
    const data = loadAll();
    data.form1 = { ...(form1.getFieldsValue?.() || {}) };
    data.form2 = { ...(form2.getFieldsValue?.() || {}) };
    saveAll(data);
  };
  useEffect(() => {
    const saved = loadAll();
    if (saved.form1) form1.setFieldsValue(saved.form1);
    if (saved.form2) form2.setFieldsValue(saved.form2);
    if (saved.form1) setBtnState1(check(saved.form1, 2));
    if (saved.form2) setBtnState2(check(saved.form2, 2));
  }, []);
  const onSubmitOne = () => {
    checkPasswordBeforeAction(() => {
      const { z1, z2 } = form1.getFieldsValue();
      const zVal = z2 - z1;
      const hVal = toHValue(zVal);
      form1.setFieldValue("z", hVal);
      // 同步到下面的 z' 输入框
      form2.setFieldValue("z", hVal);
    });
  };
  const onSubmitTwo = () => {
    checkPasswordBeforeAction(() => {
      const { z, B } = form2.getFieldsValue();
      const L = Math.floor((Math.abs(z) + B) / B);
      const S = z / L;
      form2.setFieldValue("L", toHValue(L));
      form2.setFieldValue("S", toHValue(S));
    });
  };
  const getLastResult = () => {
    const { z } = form1.getFieldsValue();
    if (z) {
      form2.setFieldValue("z", z);
    }
  };
  return (
    <>
      {document.body.clientWidth <= 1080 ? (
        <div className="cpn-wrapper-vertical">
          <Form
            style={{ maxWidth: 300 }}
            autoComplete="off"
            form={form1}
            onSubmit={onSubmitOne}
            colon=":"
            layout={document.body.clientWidth <= 780 ? "vertical" : "horizontal"}
            onValuesChange={(changed, values) => {
              setBtnState1(check(values, 2));
              const changedKey = Object.keys(changed || {})[0];
              if ((changedKey === "z1" || changedKey === "z2") && values.z1 !== undefined && values.z2 !== undefined) {
                onSubmitOne();
              }
              persist();
            }}
          >
            <FormItem
              label="起点z1"
              field="z1"
              //   labelCol={{ offset: 5 }}
              rules={[{ validator: (value, cb) => (value !== "" && value !== undefined ? cb() : cb("此项必填！")) }]}
            >
              <InputNumber placeholder="" size="large" />
            </FormItem>
            <FormItem
              label="终点z2"
              field="z2"
              rules={[{ validator: (value, cb) => (value !== "" && value !== undefined ? cb() : cb("此项必填！")) }]}
            >
              <InputNumber placeholder="" size="large" />
            </FormItem>
            <FormItem wrapperCol={{ offset: 5 }}>
              <Space>
                <Button type="primary" htmlType="submit" disabled={!btnState1.calc}>
                  立即计算
                </Button>
                <Button onClick={() => { form1.resetFields(); const data = loadAll(); data.form1 = {}; saveAll(data); setBtnState1({calc:false, reset:false}); }} disabled={!btnState1.reset}>
                  重置
                </Button>
              </Space>
            </FormItem>
            <FormItem label="结果z'" field="z">
              <InputNumber
                id="result_lc_z"
                size="large"
                readOnly
                onClick={copy}
                disabled={!btnState1.calc}
                placeholder="计算结果在此次显示"
                suffix={<IconCopy style={{ cursor: "pointer" }} onClick={copy.bind(null, null, "#result_lc_z")} />}
              />
            </FormItem>
          </Form>
          <Divider />
          <Form
            style={{ maxWidth: 300, width: "90%" }}
            autoComplete="off"
            form={form2}
            onSubmit={onSubmitTwo}
            colon=":"
            layout={document.body.clientWidth <= 780 ? "vertical" : "horizontal"}
            onValuesChange={(changed, values) => {
              setBtnState2(check(values, 2));
              const changedKey = Object.keys(changed || {})[0];
              if ((changedKey === "z" || changedKey === "B") && values.z !== undefined && values.B !== undefined) {
                onSubmitTwo();
              }
              persist();
            }}
          >
            <FormItem
              label="z'"
              field="z"
              rules={[{ validator: (value, cb) => (value !== "" && value !== undefined ? cb() : cb("此项必填！")) }]}
            >
              <Input addAfter={<IconLeft onClick={getLastResult} />} allowClear size="large" />
            </FormItem>
            <FormItem
              label="砂轮宽度B"
              field="B"
              rules={[{ validator: (value, cb) => (value > 0 ? cb() : cb("此项必填且大于 0!")) }]}
            >
              <InputNumber placeholder="" min={0} size="large" />
            </FormItem>
            <FormItem wrapperCol={{ offset: 5 }}>
              <Space>
                <Button type="primary" htmlType="submit" disabled={!btnState2.calc}>
                  立即计算
                </Button>
                <Button onClick={() => { form2.resetFields(); const data = loadAll(); data.form2 = {}; saveAll(data); setBtnState2({calc:false, reset:false}); }} disabled={!btnState2.reset}>
                  重置
                </Button>
              </Space>
            </FormItem>
            <FormItem label="切刀调用次数L" field="L">
              <Input
                id="result_lc_l"
                size="large"
                readOnly
                onClick={copy}
                disabled={!btnState2.calc}
                placeholder="计算结果在此次显示"
                suffix={<IconCopy style={{ cursor: "pointer" }} onClick={copy.bind(null, null, "#result_lc_l")} />}
              />
            </FormItem>
            <FormItem label="切刀Z移动量S" field="S">
              <Input
                id="result_lc_s"
                size="large"
                readOnly
                onClick={copy}
                disabled={!btnState2.calc}
                placeholder="计算结果在此次显示"
                suffix={<IconCopy style={{ cursor: "pointer" }} onClick={copy.bind(null, null, "#result_lc_s")} />}
              />
            </FormItem>
          </Form>
        </div>
      ) : (
        <div className="cpn-wrapper-horizontal" style={{ paddingLeft: 60 }}>
          <Row style={{ width: 1280 }} gutter={20}>
            <Col span={12}>
              <Form
                style={{ maxWidth: 300, width: "90%" }}
                autoComplete="off"
                form={form1}
                onSubmit={onSubmitOne}
                colon=":"
                // layout={document.body.clientWidth <= 1080 ? "vertical" : "horizontal"}
                layout="vertical"
                onValuesChange={(changed, values) => {
                  setBtnState1(check(values, 2));
                  const changedKey = Object.keys(changed || {})[0];
                  if ((changedKey === "z1" || changedKey === "z2") && values.z1 !== undefined && values.z2 !== undefined) {
                    onSubmitOne();
                  }
                  persist();
                }}
              >
                <FormItem
                  label="起点z1"
                  field="z1"
                  rules={[
                    { validator: (value, cb) => (value !== "" && value !== undefined ? cb() : cb("此项必填！")) },
                  ]}
                >
                  <InputNumber placeholder="" size="large" />
                </FormItem>
                <FormItem
                  label="终点z2"
                  field="z2"
                  rules={[{ validator: (value, cb) => (value !== "" && value !== undefined ? cb() : cb("此项必填!")) }]}
                >
                  <InputNumber placeholder="" size="large" />
                </FormItem>
                <FormItem wrapperCol={{ offset: 5 }}>
                  <Space>
                    <Button type="primary" htmlType="submit" disabled={!btnState1.calc}>
                      立即计算
                    </Button>
                    <Button onClick={() => { form1.resetFields(); const data = loadAll(); data.form1 = {}; saveAll(data); setBtnState1({calc:false, reset:false}); }} disabled={!btnState1.reset}>
                      重置
                    </Button>
                  </Space>
                </FormItem>
                <FormItem label="结果z'" field="z">
                  <InputNumber
                    id="result_lc_z"
                    size="large"
                    readOnly
                    onClick={copy}
                    disabled={!btnState1.calc}
                    placeholder="计算结果在此次显示"
                    suffix={<IconCopy style={{ cursor: "pointer" }} onClick={copy.bind(null, null, "#result_lc_z")} />}
                  />
                </FormItem>
              </Form>
            </Col>
            <Col span={12}>
              <Form
                style={{ maxWidth: 300, width: "90%" }}
                autoComplete="off"
                form={form2}
                onSubmit={onSubmitTwo}
                colon=":"
                // layout={document.body.clientWidth <= 1180 ? "vertical" : "horizontal"}
                layout="vertical"
                onValuesChange={(changed, values) => {
                  setBtnState2(check(values, 2));
                  const changedKey = Object.keys(changed || {})[0];
                  if ((changedKey === "z" || changedKey === "B") && values.z !== undefined && values.B !== undefined) {
                    onSubmitTwo();
                  }
                  persist();
                }}
              >
                <FormItem
                  label="z'"
                  field="z"
                  rules={[{ validator: (value, cb) => (value !== "" && value !== undefined ? cb() : cb("此项必填!")) }]}
                >
                  <Input addAfter={<IconLeft onClick={getLastResult} />} allowClear size="large" />
                </FormItem>
                <FormItem
                  label="砂轮宽度B"
                  field="B"
                  rules={[{ validator: (value, cb) => (value > 0 ? cb() : cb("此项必填且大于 0!")) }]}
                >
                  <InputNumber placeholder="" min={0} size="large" />
                </FormItem>
                <FormItem wrapperCol={{ offset: 5 }}>
                  <Space>
                    <Button type="primary" htmlType="submit" disabled={!btnState2.calc}>
                      立即计算
                    </Button>
                    <Button onClick={() => { form2.resetFields(); const data = loadAll(); data.form2 = {}; saveAll(data); setBtnState2({calc:false, reset:false}); }} disabled={!btnState2.reset}>
                      重置
                    </Button>
                  </Space>
                </FormItem>
                <FormItem label="切刀调用次数L" field="L">
                  <Input
                    id="result_lc_l"
                    size="large"
                    readOnly
                    onClick={copy}
                    disabled={!btnState2.calc}
                    placeholder="计算结果在此次显示"
                    suffix={<IconCopy style={{ cursor: "pointer" }} onClick={copy.bind(null, null, "#result_lc_l")} />}
                  />
                </FormItem>
                <FormItem label="切刀Z移动量S" field="S">
                  <Input
                    id="result_lc_s"
                    size="large"
                    readOnly
                    onClick={copy}
                    disabled={!btnState2.calc}
                    placeholder="计算结果在此次显示"
                    suffix={<IconCopy style={{ cursor: "pointer" }} onClick={copy.bind(null, null, "#result_lc_s")} />}
                  />
                </FormItem>
              </Form>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};
export default ArcCalculation;
